export var PusherEventName = /*#__PURE__*/ function(PusherEventName) {
    PusherEventName["InvoiceUpdated"] = "InvoiceUpdated";
    // payout events
    PusherEventName["PayoutXeroIntegrationStatusUpdated"] = "PayoutXeroIntegrationStatusUpdated";
    PusherEventName["PayoutQboIntegrationStatusUpdated"] = "PayoutQboIntegrationStatusUpdated";
    PusherEventName["PayoutInvoiceXeroIntegrationStatusUpdated"] = "PayoutInvoiceXeroIntegrationStatusUpdated";
    PusherEventName["PayoutInvoiceQboIntegrationStatusUpdated"] = "PayoutInvoiceQboIntegrationStatusUpdated";
    // relationship events
    PusherEventName["RelationshipCreatedFromScheduledDraft"] = "RelationshipCreatedFromScheduledDraft";
    return PusherEventName;
}({});
export var InvoiceUpdatedType = /*#__PURE__*/ function(InvoiceUpdatedType) {
    InvoiceUpdatedType["XeroIntegrationStatusUpdated"] = "XeroIntegrationStatusUpdated";
    InvoiceUpdatedType["QboIntegrationStatusUpdated"] = "QboIntegrationStatusUpdated";
    InvoiceUpdatedType["RefundFailed"] = "RefundFailed";
    InvoiceUpdatedType["Unvoided"] = "Unvoided";
    InvoiceUpdatedType["UnmarkedAsPaidExternally"] = "UnmarkedAsPaidExternally";
    return InvoiceUpdatedType;
}({});
